const context = require.context('@/assets/img/news', false, /\.(webp|png|jpe?g|gif|svg)$/);

export const getNewsThumbUrl = (thumb) => {
  if (!thumb) return '';
  const filename = thumb.replace(/^news\//, '');
  return context(`./${filename}`);
};
